<template>
  <label>
    <span>{{ props.name }}</span>
    <slot> </slot>
  </label>
</template>

<script setup lang="ts">
// superclass for form items, slot for component content
const props = defineProps({
  name: { type: String }
})
</script>

<style lang="css" scoped>
label {
  margin-bottom: 0.875rem;
  width: 100%;
  /* padding-top: 1rem;
    padding-bottom: 1rem;*/
  /* padding-bottom: 1rem;*/
}

span {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  /* width: auto;
    flex: auto;*/
}

:slotted(textarea) {
  resize: vertical;
  font-size: 12px;
  font-family: Arial, Helvetica, sans-serif;
}

:slotted(input),
:slotted(select),
:slotted(textarea) {
  display: block;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  background-color: white;
  border: 1px solid grey;
  border-radius: 0.375rem;
  font-size: 1rem;
}
:slotted(input):focus,
:slotted(select):focus,
:slotted(textarea):focus {
  /*background-color: lightcyan;*/
  border: 1px solid var(--blue);
}

:slotted(input::placeholder),
:slotted(select::placeholder) {
  color: grey;
  font-size: 0.875rem;
  font-style: italic;
}

:slotted(div) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
</style>
